'use strict';

function variantImgHover() {
    const productVariantImgOverlayClass = 'swatch-img-overlay';

    const addVariantImgOverlay = (target, hoverImg, hoverAlt) => {
        if (!target || !hoverImg) {
            return;
        }

        const imgOverlayMarkup = `
            <div class="${productVariantImgOverlayClass}">
                <div class="img-wrapper-ratio-1x1 bg-product-img">
                    <img alt="${hoverAlt}" src="${hoverImg}">
                </div>
            </div>`;
        $(target).prepend(imgOverlayMarkup);
    };

    const removeVariantImgOverlays = () => {
        $(`.${productVariantImgOverlayClass}`).remove();
    };

    $(document).on('mouseenter', 'button.js-variant-selector, a.js-variant-selector', function () {
        const $variantButton = $(this);
        const variantButtonValue = $variantButton.data('variant-name');
        const variantButtonHoverImg = $variantButton.data('variant-hover-img');

        const $variant = $variantButton.closest('.product-variant');
        const $labelSelected = $variant.find('.js-variant-value-selected');
        const labelSelectedText = $labelSelected.data('original-text') || $labelSelected.text();

        const $variantHoverTargetWrapper = $variantButton.closest($($variant.data('variant-hover-target-wrapper')));
        const $variantHoverTarget = $variantHoverTargetWrapper.find($variant.data('variant-hover-target'));

        $labelSelected.data('original-text', labelSelectedText);
        $labelSelected?.text(variantButtonValue);

        addVariantImgOverlay($variantHoverTarget, variantButtonHoverImg, variantButtonValue);
    });

    $(document).on('mouseleave', 'button.js-variant-selector, a.js-variant-selector', function () {
        const $variantButton = $(this);
        const $variant = $variantButton.closest('.product-variant');
        const $labelSelected = $variant.find('.js-variant-value-selected');

        const labelSelectedText = $labelSelected.data('original-text');
        $labelSelected?.text(labelSelectedText);
        removeVariantImgOverlays();
    });
}

module.exports = {
    variantImgHover: variantImgHover
};
